import { Subject } from 'rxjs';

export let focusChatInput = new Subject<void>();
